import { render } from "./helpCheckoutPart.vue?vue&type=template&id=ddbd9078"
import script from "./helpCheckoutPart.vue?vue&type=script&lang=js"
export * from "./helpCheckoutPart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__